import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { TourProvider } from "@reactour/tour";
const steps = [
  {
    selector: ".profileclass",
    content: "Find your profile here..",
  },
  {
    selector: ".chatbutton",
    content: "Click here to open RIVA",
  },
  {
    selector: ".awardclass",
    content: "Click to know more details about the awards",
  },
];
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
console.log("answer", Boolean(localStorage.getItem("isTourCompleted")));
root.render(
  <React.StrictMode>
    <TourProvider
      steps={steps}
      defaultOpen={false}
    >
      <App />
    </TourProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
